import type {
  ComponentData,
  FormValues,
  MaterialStockData,
  StockPropertiesData,
} from 'modules/quotes/quoteItems/components/MultipleComponentNesting/types';

export const types = {
  OPEN_DRAWER: 'common/drawers/createNestingDrawer/OPEN_DRAWER',
  CLOSE_DRAWER: 'common/drawers/createNestingDrawer/CLOSE_DRAWER',
};

export type FormData = {
  quoteId: number;
  hasVaryingThickness: boolean;
  isAcrossQuoteItems: boolean;
  isLinearNest: boolean;
  isEditing: boolean;
  materialStockData: MaterialStockData;
  tableData: ComponentData[];
  stockPropertiesList: StockPropertiesData[];
  initialValues?: Partial<FormValues>;
  nestIds?: number[];
};
export const drawer = {
  open: (payload: FormData) => {
    return {
      type: types.OPEN_DRAWER,
      payload: payload,
    };
  },
  close: () => ({
    type: types.CLOSE_DRAWER,
  }),
};
